module.exports = "https://trybtryb-legacy.web.app/img/export.823d9017.svg";